import React from "react";
import { Modal, Button, Table } from "react-bootstrap";

const ViewPharmaSalesDetails = ({ show, onHide, salesData }) => {
  if (!salesData) return null;
  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Sales Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <p>
            <strong>Patient Name:</strong> {salesData?.patientName}
          </p>
          <p>
            <strong>Prescribed By:</strong> {salesData?.prescribedBy}
          </p>
          <p>
            <strong>Place of Supply:</strong> {salesData?.placeOfSupplyName}
          </p>
          <p>
            <strong>Payment Status:</strong> {salesData?.paymentStatus}
          </p>
          <p>
            <strong>Account Type:</strong> {salesData?.accountTypeName}
          </p>
          <p>
            <strong>Bank Name:</strong> {salesData?.bankName}
          </p>
          <p>
            <strong>Sub Total:</strong> ₹{salesData?.subTotal}
          </p>
          <p>
            <strong>Discount:</strong> ₹{salesData?.discount}
          </p>
          <p>
            <strong>Paid Amount:</strong> ₹{salesData?.afterDiscount}
          </p>
        </div>

        <h5 className="mt-4">Items</h5>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Item Name</th>
              <th>Batch No</th>
              <th>Qty</th>
              <th>Rate(MRP)</th>
              <th>Expiry Date</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {salesData?.items?.map((item, index) => (
              <tr key={index}>
                <td>{item?.stockId?.name}</td>
                <td>{item?.batchNumber}</td>
                <td>{item?.quantity}</td>
                <td>{item?.rate}</td>
                <td>{item?.expiryDate?.split("T")[0]}</td>
                <td>{item?.total}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ViewPharmaSalesDetails;
